'use client';
function randomId() {
  return `mantine-${Math.random().toString(36).slice(2, 11)}`;
}

export { randomId };
//# sourceMappingURL=random-id.mjs.map
